import * as React from "react";
import { Modal, ModalSize, ModalBody, ModalFooter, Form, AlertMessage, AlertType, CustomButton, ButtonType, CustomSubmitButton } from "soprasteria-ui-library";
import { useAuth } from "../../../../App";
import { OrthodonticLkgCfPatientAdministrationApi } from "../../../../api/OrthodonticLkgCfPatientAdministrationApi";
import { UserContext, isInRole } from "../../../../contexts/UserContext";
import { LIBRETTOADMIN } from "../../../../utils/RoleConstants";

interface IUnregisterLkgCfPatientModal {
    patientId: number;
    onUnregisterLkgCfPatient: () => any;
}

export const UnregisterLkgCfPatientModal: React.FunctionComponent<IUnregisterLkgCfPatientModal> = ({ patientId, onUnregisterLkgCfPatient }) => {
    const auth = useAuth();
    const api = new OrthodonticLkgCfPatientAdministrationApi(auth);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isFormLoading, setIsFormLoading] = React.useState<boolean>(false);
    const [renderButton, setRenderButton] = React.useState<boolean>(true);
    const userInfo = React.useContext(UserContext);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles ? userInfo.roles : []);

    const onSubmit = () => {
        setIsFormLoading(true);
        api.unregisterLkgCfPatient(patientId, () => {
            document.getElementById("close-unregister-lkg-cf-patient-modal")?.click();
            onUnregisterLkgCfPatient();
            setRenderButton(false);
        }, (errorMessage: string) => {
            setIsFormLoading(false);
            setErrorMessage(errorMessage);
        })
    }

    return (
        <Modal header={hasRoleSystemAdmin ? "Avregistrera och kreditera LKG/CF-patient från systemet för käkortopedi" : "Avregistrera LKG/CF-patient från systemet för käkortopedi"} id="unregister-lkg-cf-patient-modal" preventCloseOnOutsideClick={false} modalSize={ModalSize.normal}>
            <Form onSubmit={onSubmit}>
                <ModalBody>
                    <AlertMessage alertType={AlertType.danger} duration={3000} >{errorMessage}</AlertMessage>
                    {
                        hasRoleSystemAdmin
                            ? <p>Är du säker på att patienten ska avregistreras och krediteras från systemet för käkortopedi?</p>
                            : <p>Är du säker på att patienten ska avregistreras från systemet för käkortopedi?</p>
                    }
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton buttonType={ButtonType.general} data-dismiss="modal" buttonText="Avbryt" id="close-unregister-lkg-cf-patient-modal" />
                        {
                            renderButton ?
                                <CustomSubmitButton isLoading={isFormLoading}>Avregistrera patient</CustomSubmitButton>
                                : null
                        }
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    )
}